export default {
  "1": { country: 1, name: "Kyiv" },
  "2": { country: 1, name: "Lviv" },
  "3": { country: 1, name: "Odessa" },
  "4": { country: 1, name: "Dnipro" },
  "5": { country: 1, name: "Kharkiv" },

  "6": { country: 2, name: "Berlin" },
  "7": { country: 2, name: "Dortmund" },
  "8": { country: 2, name: "Drezden" },
  "9": { country: 2, name: "Hamburg" },
  "10": { country: 2, name: "Koln" },

  "11": { country: 3, name: "Paris" },
  "12": { country: 3, name: "Lyon" },
  "13": { country: 3, name: "Toulouse" },
  "14": { country: 3, name: "Marseille" },
  "15": { country: 3, name: "Bordeaux" },

  "16": { country: 4, name: "Madrid" },
  "17": { country: 4, name: "Barcelona" },
  "18": { country: 4, name: "Sevilla" },
  "19": { country: 4, name: "Bilbo" },
  "20": { country: 4, name: "Malaga" },

  "21": { country: 5, name: "Washington" },
  "22": { country: 5, name: "San-Francisco" },
  "23": { country: 5, name: "New-York" },
  "24": { country: 5, name: "Las-Vegas" },
  "25": { country: 5, name: "Miami" },

  "26": { country: 6, name: "Yerevan" },
  "27": { country: 6, name: "Gyumri" },
  "28": { country: 6, name: "Ararat" },
};
